import EventsList from '../pages/EventsList';
import Stats from '../pages/Stats';
import Home from '../pages/Home';

const routes = [
    {
        title: 'Home',
        path: "/",
        element: <Home />,
    },
    {
        title: 'Sports Events List',
        path: "sport/:compId",
        element: <EventsList />,
    },
    {
        title: 'Stats',
        path: "stats/:eventId",
        element: <Stats />,
    },
];

export default routes;